import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import { categories, articles } from '@/mocks/data';

const stats = [
  { value: '1.2亿+', label: '累计用户' },
  { value: '500万+', label: '日均下载量' },
  { value: '99.7%', label: '安全检测率' },
  { value: '300%', label: '速度提升' },
];

const features = [
  { icon: 'ri-shield-check-line', title: '安全可靠', desc: '五层安全防护体系，AI智能病毒查杀，绿色无捆绑安装包' },
  { icon: 'ri-flashlight-line', title: '极速下载', desc: 'P2P多线程加速技术，下载速度提升300%，充分利用带宽' },
  { icon: 'ri-device-line', title: '多端兼容', desc: 'Windows、macOS、Android、iOS全平台覆盖，数据云端同步' },
  { icon: 'ri-cloud-line', title: '智能管理', desc: 'AI自动分类整理文件，批量任务管理，断点续传永不断线' },
];

const faqs = [
  { q: '开云下载是否完全免费？', a: '开云下载基础版完全免费，提供核心下载功能、安全检测和基本文件管理。专业版年费99元，额外提供AI智能分类、云端同步、远程下载等高级功能。' },
  { q: '开云下载安装包是否安全无毒？', a: '开云下载安装包通过360、腾讯、瑞星等多家主流安全软件检测认证，绿色无捆绑。建议只从开云下载官网获取安装包，以确保文件安全。' },
  { q: '开云下载支持哪些操作系统？', a: '开云下载目前支持Windows 7/8/10/11、macOS 10.14+、Android 7.0+和iOS 13+四大平台，覆盖了99%以上的用户设备。' },
  { q: '下载速度慢怎么办？', a: '可以尝试以下方法：1) 增加并发线程数至8-16；2) 开启P2P加速功能；3) 关闭其他占用带宽的应用；4) 更换DNS服务器为114.114.114.114。详细优化指南请参考我们的教程文章。' },
  { q: '如何从旧电脑迁移开云下载的数据？', a: '登录开云账号后，下载历史、设置偏好等数据会自动云端同步。在新电脑上安装开云下载并登录同一账号，所有数据即可自动恢复。本地文件可通过开云下载的文件传输功能迁移。' },
];

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        {/* Hero */}
        <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20abstract%20technology%20background%20with%20warm%20orange%20and%20teal%20gradient%20accents%2C%20soft%20geometric%20shapes%2C%20clean%20flowing%20lines%2C%20digital%20download%20concept%2C%20bright%20and%20airy%20atmosphere%2C%20light%20background%20with%20subtle%20tech%20elements%2C%20professional%20and%20trustworthy%20feel&width=1920&height=1080&seq=hero-kaiyun-2026&orientation=landscape"
            alt="开云下载 - 安全极速下载平台"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
          <div className="relative z-10 w-full text-center px-4 md:px-6 pt-16">
            <div className="max-w-4xl mx-auto">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
                <i className="ri-verified-badge-line text-accent-400 text-sm"></i>
                <span className="text-sm text-background-50/90">官方正版 · 安全极速下载</span>
              </div>
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-background-50 font-heading leading-tight mb-6">
                开云下载
                <br />
                <span className="text-primary-300">让每一次下载都安全无忧</span>
              </h1>
              <p className="text-lg md:text-xl text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
                开云下载官方平台，提供最新版本安全极速下载服务。支持多端设备一键安装，
                稳定流畅，海量资源免费获取。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a
                  href="/"
                  className="px-8 py-4 rounded-xl bg-primary-500 text-background-50 text-base font-bold hover:bg-primary-600 transition-all duration-200 shadow-lg shadow-primary-500/30 whitespace-nowrap cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-download-cloud-2-line text-xl"></i>
                  立即免费下载
                </a>
                <Link
                  to="/category/system-tools"
                  className="px-8 py-4 rounded-xl bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 text-base font-semibold hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  浏览全部软件
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
              <p className="mt-6 text-xs text-background-50/50">
                支持 Windows / macOS / Android / iOS · 当前版本 v5.2.1
              </p>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="relative -mt-16 z-20">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <div className="bg-background-50 rounded-2xl border border-background-200/70 grid grid-cols-2 md:grid-cols-4 divide-x divide-y md:divide-y-0 divide-background-200/70">
              {stats.map((s) => (
                <div key={s.label} className="flex flex-col items-center justify-center py-8 px-4">
                  <span className="text-3xl md:text-4xl font-extrabold text-primary-500 font-heading">{s.value}</span>
                  <span className="text-sm text-foreground-600 mt-2">{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="py-20 md:py-28">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-14">
              <h2 className="text-3xl md:text-4xl font-bold text-foreground-900 font-heading mb-4">
                为什么选择 <span className="text-primary-500">开云下载</span>？
              </h2>
              <p className="text-foreground-600 max-w-2xl mx-auto">
                四大核心优势，重新定义下载体验
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((f) => (
                <div
                  key={f.title}
                  className="bg-background-50 rounded-xl border border-background-200/70 p-6 hover:border-primary-300 transition-all duration-300 group cursor-default"
                >
                  <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-500 transition-colors duration-300">
                    <i className={`${f.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
                  </div>
                  <h3 className="text-lg font-semibold text-foreground-900 mb-2">{f.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-14">
              <h2 className="text-3xl md:text-4xl font-bold text-foreground-900 font-heading mb-4">
                海量软件 · 分类浏览
              </h2>
              <p className="text-foreground-600 max-w-2xl mx-auto">
                涵盖八大热门类别，快速找到你需要的软件工具
              </p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="bg-background-50 rounded-xl border border-background-200/70 p-5 hover:border-primary-300 hover:shadow-sm transition-all duration-200 group cursor-pointer"
                >
                  <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-3 group-hover:bg-accent-500 transition-colors duration-200">
                    <i className={`${cat.icon} text-lg text-accent-600 group-hover:text-background-50 transition-colors duration-200`}></i>
                  </div>
                  <h3 className="font-semibold text-foreground-900 text-sm mb-1">{cat.name}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{cat.desc}</p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Popular Articles */}
        <section className="py-20 md:py-28">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-14">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold text-foreground-900 font-heading mb-2">
                  精选文章
                </h2>
                <p className="text-foreground-600">最新使用教程与技术分享</p>
              </div>
              <Link
                to="/category/system-tools"
                className="hidden sm:flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                更多文章 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                { article: articles[0], img: 'https://readdy.ai/api/search-image?query=Modern%20clean%20technology%20illustration%20related%20to%20software%20and%20digital%20downloads%2C%20minimalist%20style%20with%20warm%20orange%20accents%20on%20light%20neutral%20background%2C%20abstract%20tech%20concept%2C%20professional%20and%20friendly%20aesthetic&width=800&height=450&seq=art-001&orientation=landscape' },
                { article: articles[1], img: 'https://readdy.ai/api/search-image?query=Mobile%20app%20download%20concept%20with%20smartphone%20and%20clean%20modern%20interface%20design%2C%20warm%20orange%20accents%20on%20light%20neutral%20background%2C%20minimalist%20tech%20illustration%2C%20professional%20and%20friendly&width=800&height=450&seq=art-002&orientation=landscape' },
                { article: articles[2], img: 'https://readdy.ai/api/search-image?query=High%20speed%20internet%20download%20concept%20with%20abstract%20data%20flow%20visualization%2C%20warm%20orange%20and%20teal%20gradients%2C%20minimalist%20technology%20illustration%2C%20clean%20modern%20style&width=800&height=450&seq=art-003&orientation=landscape' },
                { article: articles[3], img: 'https://readdy.ai/api/search-image?query=Cybersecurity%20shield%20protection%20concept%20with%20abstract%20digital%20security%20elements%2C%20warm%20orange%20accents%20on%20light%20neutral%20background%2C%20modern%20tech%20illustration%2C%20professional%20style&width=800&height=450&seq=art-004&orientation=landscape' },
                { article: articles[4], img: 'https://readdy.ai/api/search-image?query=Artificial%20intelligence%20and%20cloud%20computing%20concept%20with%20abstract%20digital%20brain%20and%20network%2C%20warm%20orange%20and%20teal%20gradients%2C%20minimalist%20tech%20illustration%2C%20clean%20modern&width=800&height=450&seq=art-005&orientation=landscape' },
                { article: articles[5], img: 'https://readdy.ai/api/search-image?query=Comparison%20chart%20and%20analytics%20concept%20with%20abstract%20data%20visualization%2C%20warm%20orange%20accents%20on%20light%20neutral%20background%2C%20modern%20minimalist%20tech%20illustration%2C%20professional&width=800&height=450&seq=art-006&orientation=landscape' },
              ].map(({ article, img }) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-200 group cursor-pointer"
                >
                  <div className="aspect-[16/9] overflow-hidden">
                    <img
                      src={img}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                      <span className="flex items-center gap-1">
                        <i className="ri-calendar-line"></i>
                        {article.date}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        {article.readTime}
                      </span>
                    </div>
                    <h3 className="font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                      {article.excerpt}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-14">
              <h2 className="text-3xl md:text-4xl font-bold text-foreground-900 font-heading mb-4">
                常见问题
              </h2>
              <p className="text-foreground-600">快速解答您的疑问</p>
            </div>
            <div className="flex flex-col gap-4">
              {faqs.map((faq, i) => (
                <details key={i} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
                  <summary className="flex items-center justify-between px-6 py-5 cursor-pointer list-none">
                    <h4 className="text-base font-semibold text-foreground-900 pr-4">{faq.q}</h4>
                    <div className="w-6 h-6 rounded-full bg-background-200/70 flex items-center justify-center flex-shrink-0 group-open:bg-primary-500 transition-colors">
                      <i className="ri-add-line text-sm text-foreground-600 group-open:text-background-50 group-open:hidden"></i>
                      <i className="ri-subtract-line text-sm text-background-50 hidden group-open:block"></i>
                    </div>
                  </summary>
                  <div className="px-6 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-20 md:py-28 relative overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20digital%20background%20with%20flowing%20orange%20and%20teal%20shapes%2C%20soft%20geometric%20patterns%2C%20modern%20technology%20feel%2C%20clean%20bright%20atmosphere%2C%20professional%20tech%20brand%20banner%20background&width=1920&height=600&seq=cta-kaiyun-bottom&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
          <div className="relative z-10 text-center px-4 md:px-6">
            <h2 className="text-3xl md:text-4xl font-bold text-background-50 font-heading mb-4">
              准备好体验极速下载了吗？
            </h2>
            <p className="text-background-50/80 mb-8 max-w-xl mx-auto">
              立即下载开云下载最新版，开启安全、快速、智能的下载之旅
            </p>
            <a
              href="/"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-xl bg-primary-500 text-background-50 text-base font-bold hover:bg-primary-600 transition-all duration-200 shadow-lg shadow-primary-500/30 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-cloud-2-line text-xl"></i>
              免费下载开云下载
            </a>
          </div>
        </section>

        {/* Schema.org WebPage */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "开云下载 - 官方正版安全下载，极速体验",
            "description": "开云下载官方平台，提供最新版本安全极速下载服务。支持多端设备一键安装，稳定流畅，海量资源免费获取。",
            "url": "https://www.kaiyunxiazai.com/",
            "primaryImageOfPage": "https://readdy.ai/api/search-image?query=Modern%20minimalist%20abstract%20technology%20background%20with%20warm%20orange%20and%20teal%20gradient%20accents&width=1920&height=1080&seq=hero-kaiyun-2026&orientation=landscape",
            "isPartOf": { "@type": "WebSite", "name": "开云下载", "url": "https://www.kaiyunxiazai.com/" }
          })
        }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqs.map(faq => ({
              "@type": "Question",
              "name": faq.q,
              "acceptedAnswer": { "@type": "Answer", "text": faq.a }
            }))
          })
        }} />
      </main>

      <Footer />
    </>
  );
}